import { AxiosResponse } from "axios";

export interface ISpotErrorResponse {
  status: number;
  message: string;
  validationError?: Record<string, string>;
  request?: Record<string, any>;
  response?: Record<string, any>;
}

export interface IAxiosErrorResponse extends AxiosResponse {}

export class RepoSpotError extends Error {
  error: ISpotErrorResponse;

  constructor(error: ISpotErrorResponse) {
    super(error.message);
    this.error = error;
    this.name = this.constructor.name;
  }
}
